import { useContext } from 'react'
import styled from 'styled-components'

import { FavoriteButton } from 'favorites/FavoriteButton'
import { FavoritesModalMobile } from 'favorites/FavoritesModalMobile'
import { LoginPanelModal } from 'favorites/LoginPanelModal'
import colors from 'shared/lib/colors'

import { useOpenProductModal } from 'favorites/hooks/useOpenProductModal'
import MobileProductPictureCarousel from 'productTemplate/components/MobileProductPictureCarousel'
import ProductDetails from 'productTemplate/components/ProductDetails'
import { ProductTemplateContext } from 'productTemplate/components/ProductTemplateContextProvider'
import ProductTitle from 'productTemplate/components/ProductTitle'
import { ProductTemplateLayoutProps } from 'productTemplate/types/IProductTemplateLayoutProps'
import { renderUntil } from 'shared/hocs/render'
import { useUser } from 'shared/hooks/useUser'
import { media, styles } from 'shared/lib'
import { setIsSaveFavoritesModalOpen } from 'store/favoritesSlice'
import { useAppDispatch, useAppSelector } from 'store/hooks'

const ProductTemplateMobileLayout = (props: ProductTemplateLayoutProps) => {
  const { isAuthenticated } = useUser()
  const { isSaveFavoritesModalOpen } = useAppSelector((state) => state.favorites)
  const { productTemplate } = useContext(ProductTemplateContext)
  const { className } = props
  const dispatch = useAppDispatch()

  const handleFavoriteClick = () => {
    dispatch(setIsSaveFavoritesModalOpen(true))
  }

  const handleCloseModal = () => {
    dispatch(setIsSaveFavoritesModalOpen(false))
  }

  useOpenProductModal()

  return (
    <ProductMobileLayout className={className}>
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'start',
            marginBottom: '8px',
          }}
        >
          <ProductTitle
            brand={productTemplate.brandName}
            name={productTemplate.name}
            sku={productTemplate.sku}
            description={productTemplate.details}
            releaseDate={productTemplate.releaseDate.shortDisplay}
          />
          <div
            style={{
              marginLeft: '8px',
              marginTop: '12px',
              display: 'flex',
              alignItems: 'flex-end',
              textWrapMode: 'nowrap',
            }}
          >
            <FavoriteButton
              onClick={handleFavoriteClick}
              productTemplateId={productTemplate?.id}
              productTemplateSlug={productTemplate?.slug}
            />
          </div>
        </div>
        <MobileProductPictureCarousel pictures={productTemplate.pictures} />
      </div>
      <ProductInfo>
        <ProductDetails />
      </ProductInfo>

      {!isAuthenticated && isSaveFavoritesModalOpen && (
        <LoginPanelModal
          handleCloseLoginPanelModal={handleCloseModal}
          location="pdp_favorite"
          flow="viewFavorites"
        />
      )}
      {isAuthenticated && isSaveFavoritesModalOpen && (
        <FavoritesModalMobile
          isApparel={productTemplate?.productCategory !== 'shoes'}
          sizeCategory={productTemplate?.sizeCategory}
          handleCloseModal={handleCloseModal}
          productTemplateId={productTemplate?.id}
        />
      )}
    </ProductMobileLayout>
  )
}
export default renderUntil.large(ProductTemplateMobileLayout)

const ProductMobileLayout = styled.div`
  background-color: ${colors.FC2_WHITE};
  padding: 20px ${styles.mobilePageLayoutPadding} 0;
  ${media.large`
    padding: 30px ${styles.mobilePageLayoutPadding} 0;
  `}
`

const ProductInfo = styled.div`
  display: flex;
  justify-content: center;
`
